/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Roleapplicationscope2Inputs */

const en_entity_roleapplicationscope2 = /** @type {(inputs: Entity_Roleapplicationscope2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Application Scope`)
};

const de_entity_roleapplicationscope2 = /** @type {(inputs: Entity_Roleapplicationscope2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen-Geltungsbereich App`)
};

/**
* | output |
* | --- |
* | "Role Application Scope" |
*
* @param {Entity_Roleapplicationscope2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_roleapplicationscope2 = /** @type {((inputs?: Entity_Roleapplicationscope2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Roleapplicationscope2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_roleapplicationscope2(inputs)
	return de_entity_roleapplicationscope2(inputs)
});
export { entity_roleapplicationscope2 as "entity_roleApplicationScope" }